<template>
	<div class="card-reviewDetails" v-if="Object.keys(topicInfo).length">
		<h3 class="text-center">{{ topicInfo.name }}</h3>
		<div class="row row-reviewDetails">
			<div class="col-6 col-md-3">负责人姓名：{{ getAllEmcee }}</div>
			<div class="col-6 col-md-3">申报单位：{{ topicInfo.unitName }}</div>
			<div class="col-6 col-md-3">学段：{{ topicInfo.learningTypeName }}</div>
			<div class="col-6 col-md-3">领域：{{ topicInfo.researchFieName }}</div>
			<div class="col-6 col-md-3">预结题时间：{{ topicInfo.expectedClosingTime | getTime }}</div>
			<div class="col-6 col-md-3">学科：{{ topicInfo.disciplineName }}</div>
			<div class="col-6 col-md-3">专业技术职务：{{ topicInfo.professionalSkillPostName }}</div>
			<div class="col-6 col-md-3">学历：{{ topicInfo.lastDegreeId }}</div>
			<div class="col-6 col-md-3">学位：{{ topicInfo.lastQualificationId }}</div>
			<div class="col-6 col-md-3">研究专长：{{ topicInfo.areasSpecialization }}</div>
			<div class="col-6 col-md-3">出生日期：{{ topicInfo.birthTime | getTime }}</div>
			<div class="col-6 col-md-3">行政职务：{{ topicInfo.administrativeDuties }}</div>
			<div class="col-12">核心成员：{{ topicInfo.coreMember | getMember }}</div>
		</div>
		<!-- 审核文件列表 -->
		<ul class="file-list">
			<li class="file-item" :class="{ active: curFileTitleIndex === index }" v-for="(item, index) in fileTitleList" :key="index" @click="changeFileTitle(index)">{{ item }}</li>
		</ul>

		<!-- 在线浏览文档 -->
		<div class="view"><iframe ref="myIframe" height="100%" width="100%"></iframe></div>

		<!-- 审核意见列表 -->
		<div class="comments-list" v-if="topicInfo.schoolAuditList">
			<div class="form-group row mb-2" v-for="(item, index) in topicInfo.schoolAuditList" :key="index">
				<label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{ item.auditType == 1 ? '区级审核' + (index + 1) : '学校审核' + (index + 1) }}</label>
				<div class="col-md-9 col-10">
					<table class="table table-bordered table-centered mb-0">
						<tbody>
							<tr>
								<th>审核意见</th>
								<td>{{ item.auditState == 2 ? '不通过' : item.auditState == 1 ? '通过' : '退回修改' }}</td>
								<th>审核人</th>
								<td>{{ item.auditName }}</td>
								<th>审核时间</th>
								<td>{{ item.createTime | getTime }}</td>
							</tr>
							<tr>
								<th>审核说明</th>
								<td colspan="5">{{ item.auditExplain }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-md-1 col-2"><span class="required"></span></div>
			</div>
		</div>

		<div class="btn_wrap"><el-button type="primary" @click="$emit('goback')">返回</el-button></div>
		<!-- 表单 -->
		<!-- <el-form :model="auditForm" :rules="auditFormRules" ref="auditFormRef" label-width="100px">
				<el-form-item label="审核意见" prop="auditState">
					<el-radio-group v-model="auditForm.auditState">
						<el-radio :disabled="isOverTime" :label="0">退回修改</el-radio>
						<el-radio :disabled="isOverTime" :label="1">通过</el-radio>
						<el-radio :label="2">不通过</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="审核说明" prop="auditExplain"><el-input v-model="auditForm.auditExplain" type="textarea" autosize></el-input></el-form-item>
			</el-form> -->

		<!-- <div class="text-center">
				<button type="button" class="btn btn-info" @click="submitAudit">确定</button>
				<button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">关 闭</button>
			</div> -->
	</div>
</template>

<script>
export default {
	props: {
		topicInfo: {
			type: Object,
			default(){
				return {}
			}
		}
	},
	data() {
		return {
			curFileTitleIndex: 0,
			fileTitleList: ['课题申请书','匿名评审活页']
		};
	},
	filters: {
		getMember(val) {
			if (val) {
				return val.replace(/,/g, '、');
			}
		}
	},
	computed: {
		getAllEmcee() {
			if (Object.keys(this.topicInfo).length) {
				if (this.topicInfo.twoEmceeName) {
					return `${this.topicInfo.oneEmceeName}、${this.topicInfo.twoEmceeName}`;
				} else {
					return this.topicInfo.oneEmceeName;
				}
			}
		}
	},
	created() {
		let projectData = JSON.parse(sessionStorage.getItem('projectData')||'{}');
		// console.log('项目数据',this.projectData);
		if (Object.keys(projectData).length) {
			// 如果没有匿名评审页,那么只渲染课题申请书
			if(projectData.anonymousReviewState==0){
				this.fileTitleList=['课题申请书']
			}
		}
	},
	mounted() {
		if (Object.keys(this.topicInfo).length) {
			this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
		}
	},
	methods: {
		// 改变文件标题索引
		changeFileTitle(index) {
			this.curFileTitleIndex = index;
			if (index == 0) {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`);
			} else {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.anonymousReview}`);
			}
		}
	}
};
</script>

<style scoped lang="scss">
	.view {
		width: 1000px;
		height: 500px;
	}
	.comments-list{
		margin-top: 20px;
	}
	.file-list{
		width: 100%;
		display: flex;
		justify-content: center;
		padding-left: 0;
		list-style: none;
		.file-item{
			font-size: 24px;
			text-align: center;
			width: 50%;
			border-bottom: 2px solid #eee;
			cursor: pointer;
		}
	}
	.file-item.active{
		border-color: #00a2e8;
	}
	.btn_wrap{
		text-align: center;
	}
</style>
